import { render, staticRenderFns } from "./FieldEdit.vue?vue&type=template&id=87b6e1c6&scoped=true&"
import script from "./FieldEdit.vue?vue&type=script&lang=js&"
export * from "./FieldEdit.vue?vue&type=script&lang=js&"
import style0 from "./FieldEdit.vue?vue&type=style&index=0&id=87b6e1c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b6e1c6",
  null
  
)

export default component.exports